import { useState } from 'react';

import { Link } from 'react-router';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import newBadge from 'assets/images/productPages/new-product-badge.png';

import type { Product } from '../types';

const CardContainer = styled(Link)`
  position: relative;
  display: block;
  color: inherit;
`;

const CardInfoContainer = styled.div`
  margin-top: ${theme.spacing['6x']};
`;

const ImageContainer = styled.div`
  height: 265px;
  border-radius: ${theme.radius.xs};
  overflow: hidden;
  ${legacyTheme.breakpoints.up('sm')} {
    height: 195px;
  }
  ${legacyTheme.breakpoints.up('md')} {
    height: 350px;
  }
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledTypographyProductName = styled(Typography)`
  font-size: ${theme.typography.fontSize.md};
  font-weight: ${theme.typography.fontWeight.medium};
`;
const StyledTypographyProductPrice = styled(Typography)`
  font-size: ${theme.typography.fontSize.md};
`;

const StyledNewBadge = styled(Image)`
  position: absolute;
  top: 20px;
  left: 20px;
`;

type ProductCardProps = {
  dataFrom?: string;
  dataClick?: string;
  product: Product;
};

export const ProductCard = ({ dataFrom, dataClick, product }: ProductCardProps) => {
  const [isHovered, setHovered] = useState(false);

  const {
    label,
    priceWithSubscription,
    productSquaredPictureHover,
    productSquaredPicture,
    productPageUrl,
    tag,
  } = product;

  return (
    <CardContainer
      data-click={dataClick}
      data-from={dataFrom}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => setHovered(false)}
      to={productPageUrl}
    >
      <ImageContainer>
        {tag === 'new' && <StyledNewBadge alt="new badge" height={50} src={newBadge} width={50} />}
        <StyledImage
          alt={`Prose Custom ${label} packaging`}
          src={isHovered ? productSquaredPictureHover : productSquaredPicture}
        />
      </ImageContainer>
      <CardInfoContainer>
        <StyledTypographyProductName markupName="h3" variant="p1">
          Custom {label}
        </StyledTypographyProductName>
        <Spacer size={2} />
        <StyledTypographyProductPrice variant="p1">{`From $${priceWithSubscription.toFixed(
          2,
        )}`}</StyledTypographyProductPrice>
      </CardInfoContainer>
    </CardContainer>
  );
};
